import React, {FC, memo} from "react";
import {ParcelShop} from "./parcel-shop";
import {IGLSParcel} from "@montana/models/generated/cms.interface";

interface IParcelShopsListProps {
    shops?: IGLSParcel[];
    onChange: (e: string) => void;
}

export const ParcelShopsList: FC<IParcelShopsListProps> = memo((props: IParcelShopsListProps) => {
    const {shops, onChange} = props;

    return (
        <div className="parcel-options-test">
            {!!shops && shops.map((shop) => (
                <>
                    <label className="checkable checkable--radio shipping-options-form__option">
                        <input type="radio" name="parcelShop" value={shop.numberID}
                            onClick={() => {
                                onChange(shop.numberID ?? '');
                            }}
                        />
                        <span className="checkable__indicator" aria-hidden="true"></span>
                        <div className="checkable__label">
                            <ParcelShop shop={shop}/>
                        </div>
                    </label>
                </>
            ))}

        </div>
    );
});
